import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { logout, generateId } from "./Utility";
import customFetch from "./apicall/api";
import toast, { Toaster } from 'react-hot-toast';

function PromiseToPay() {
    const history = useHistory();
    const [flag] = useState(0);
    const location = history.location;
    const { smsmobile, Lead_Name, HH_ID, household_id, api_token } = location.state || {};
    const generate_Id1 = generateId(10);

    const [ptpDate, setPtpDate] = useState('');
    const [ptpAmount, setPtpAmount] = useState('');
    const [ptpHistory, setPtpHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notes, setNotes] = useState('');
    const [isListening, setIsListening] = useState(false);
    const [recognition, setRecognition] = useState(null);
    const [capturedPhoto, setCapturedPhoto] = useState(null);
    const [gpsCoordinates, setGpsCoordinates] = useState(null);
    const [showCamera, setShowCamera] = useState(false);
    const [cameraStream, setCameraStream] = useState(null);
    const [marginPeriod, setMarginPeriod] = useState(3); // configurable margin period in days
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [followUpRemarksEnabled, setFollowUpRemarksEnabled] = useState(false);
    const [followUpRemarksOptions, setFollowUpRemarksOptions] = useState([]);
    const [selectedFollowUpRemark, setSelectedFollowUpRemark] = useState('');
    const [followUpRemarkText, setFollowUpRemarkText] = useState('');
    const [customerPaid, setCustomerPaid] = useState(false); // kept for reference, but UI is commented out
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [currentPtpId, setCurrentPtpId] = useState(null); // Track which PTP record is being photographed
    const [currentPtpRecord, setCurrentPtpRecord] = useState(null); // Store the complete PTP record with _id
    // const [closedPTPs, setClosedPTPs] = useState({}); // Track which PTPs are closed
    const [showImagePreview, setShowImagePreview] = useState(false); // Show/hide image preview modal
    const [previewImageUrl, setPreviewImageUrl] = useState(''); // URL of image to preview
    const [isImageLoading, setIsImageLoading] = useState(false); // Loading state for image

    // Initialize offline database
    useEffect(() => {
        initOfflineDB();

        // Online/Offline listeners
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    const initOfflineDB = () => {
        if (!window.indexedDB) {
            console.log("IndexedDB not supported");
            return;
        }

        const request = indexedDB.open('PromiseToPayDB', 1);

        request.onerror = () => {
            console.error("Database failed to open");
        };

        request.onsuccess = () => {
            console.log("Database opened successfully");
        };

        request.onupgradeneeded = (e) => {
            const db = e.target.result;

            if (!db.objectStoreNames.contains('ptpRecords')) {
                const objectStore = db.createObjectStore('ptpRecords', { keyPath: 'id', autoIncrement: true });
                objectStore.createIndex('household_number', 'household_number', { unique: false });
                objectStore.createIndex('synced', 'synced', { unique: false });
            }
        };
    };

    const handleOnline = () => {
        setIsOnline(true);
        toast.success('Back online! Syncing data...');
        syncOfflineData();
    };

    const handleOffline = () => {
        setIsOnline(false);
        toast.error('You are offline. Data will be synced when connection is restored.');
    };

    const syncOfflineData = async () => {
        const request = indexedDB.open('PromiseToPayDB', 1);

        request.onsuccess = (e) => {
            const db = e.target.result;
            const transaction = db.transaction(['ptpRecords'], 'readwrite');
            const objectStore = transaction.objectStore('ptpRecords');
            const query = objectStore.getAll();

            query.onsuccess = async () => {
                const allRecords = query.result;
                // Filter for unsynced records
                const records = allRecords.filter(record => record.synced === false);

                for (const record of records) {
                    try {
                        const formdata = new FormData();
                        formdata.append("household_number", record.household_number);
                        formdata.append("employee_name", record.employee_name);
                        formdata.append("employee_id", record.employee_id);

                        if (record.promise_date) {
                            formdata.append("promise_date", record.promise_date);
                        }
                        if (record.promise_amount) {
                            formdata.append("promise_amount", record.promise_amount);
                        }
                        if (record.remarks) {
                            formdata.append("remarks", record.remarks);
                        }
                        if (record.photo) {
                            const photoBlob = await fetch(record.photo).then(r => r.blob());
                            formdata.append("photo", photoBlob, "visit_photo.jpg");
                        }
                        if (record.gps_coordinates) {
                            formdata.append("gps_coordinates", JSON.stringify(record.gps_coordinates));
                        }

                        const uid = localStorage.getItem("in_userid");
                        const generate_Id = generateId(10);

                        const response = await customFetch(
                            process.env.REACT_APP_URL + "/add/household/ptp",
                            {
                                method: "POST",
                                body: formdata,
                                headers: {
                                    "api-token": api_token,
                                    component_id: generate_Id1,
                                    apiId: generate_Id,
                                    api_group_id: "",
                                    component: "PromiseToPay",
                                    user_id: uid,
                                },
                            }
                        );

                        const data = await response.json();

                        if (response.ok && data.status == 1) {
                            // Mark as synced
                            const updateTransaction = db.transaction(['ptpRecords'], 'readwrite');
                            const updateStore = updateTransaction.objectStore('ptpRecords');
                            record.synced = true;
                            updateStore.put(record);

                            toast.success('Record synced successfully');
                        }
                    } catch (error) {
                        console.error('Error syncing record:', error);
                    }
                }

                fetchHouseholdData();
            };
        };
    };

    const saveToOfflineDB = (record) => {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open('PromiseToPayDB', 1);

            request.onsuccess = (e) => {
                const db = e.target.result;
                const transaction = db.transaction(['ptpRecords'], 'readwrite');
                const objectStore = transaction.objectStore('ptpRecords');

                const addRequest = objectStore.add(record);

                addRequest.onsuccess = () => {
                    resolve();
                };

                addRequest.onerror = () => {
                    reject(addRequest.error);
                };
            };

            request.onerror = () => {
                reject(request.error);
            };
        });
    };

    const handle_amount_update = (e) => {
        let value = e.target.value;
        if (value === '') {
            setPtpAmount('');
            return;
        }

        // Remove any 'e', 'E', '-', '+' characters immediately
        value = value.replace(/[eE\-+]/g, '');
        
        // Only allow digits and decimal point
        value = value.replace(/[^0-9.]/g, '');

        // Remove leading zeros before digits (but keep single 0 before decimal)
        if (/^0[0-9]/.test(value)) {
            value = value.replace(/^0+/, '');
        }

        // Only allow one decimal point
        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts[1];
        }

        // Check if the value is a valid positive number
        const numericValue = parseFloat(value);
        if (value !== '' && (isNaN(numericValue) || numericValue < 0)) {
            return; // Don't update if invalid
        }

        setPtpAmount(value);
    };

    // Follow-up remarks will be fetched from the API; no local defaults.

    // Camera and GPS functions
    const captureGPS = () => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                toast.error('Geolocation is not supported by your browser');
                reject(new Error('Geolocation not supported'));
                return;
            }

            // Show loading message
            toast('Getting accurate GPS location...', { duration: 2000 });

            const options = {
                enableHighAccuracy: true, // Request high accuracy GPS
                timeout: 15000, // Wait up to 15 seconds
                maximumAge: 0 // Don't use cached position, get fresh coordinates
            };

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const coords = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        accuracy: position.coords.accuracy, // in meters
                        altitude: position.coords.altitude,
                        altitudeAccuracy: position.coords.altitudeAccuracy,
                        heading: position.coords.heading,
                        speed: position.coords.speed,
                        timestamp: new Date().toISOString()
                    };
                    
                    setGpsCoordinates(coords);
                    
                    // Show accuracy feedback
                    if (coords.accuracy <= 10) {
                        toast.success(`GPS captured with excellent accuracy (±${coords.accuracy.toFixed(1)}m)`);
                    } else if (coords.accuracy <= 50) {
                        toast.success(`GPS captured with good accuracy (±${coords.accuracy.toFixed(1)}m)`);
                    } else {
                        toast.success(`GPS captured (±${coords.accuracy.toFixed(1)}m accuracy)`);
                    }
                    
                    resolve(coords);
                },
                (error) => {
                    let errorMessage = 'Unable to get GPS location';
                    
                    switch(error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage = 'GPS permission denied. Please enable location access.';
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage = 'GPS location unavailable. Please check your device settings.';
                            break;
                        case error.TIMEOUT:
                            errorMessage = 'GPS request timed out. Please try again.';
                            break;
                        default:
                            errorMessage = 'GPS error: ' + error.message;
                    }
                    
                    toast.error(errorMessage);
                    reject(error);
                },
                options
            );
        });
    };

    const openCamera = async () => {
        try {
            // Request camera with fallback options for better compatibility
            const constraints = {
                video: {
                    facingMode: 'environment', // Prefer back camera on mobile
                    width: { ideal: 1920 },
                    height: { ideal: 1080 }
                },
                audio: false
            };

            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            setCameraStream(stream);
            setShowCamera(true);

            // Wait a bit for React to render the video element
            setTimeout(() => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    // Ensure video plays on iOS
                    videoRef.current.play().catch(err => {
                        console.error('Error playing video:', err);
                    });
                }
            }, 100);

            toast.success('Camera opened successfully');
        } catch (error) {
            console.error('Camera error:', error);
            
            // Provide more helpful error messages
            if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                toast.error('Camera permission denied. Please allow camera access in your browser settings.');
            } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
                toast.error('No camera found on this device.');
            } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
                toast.error('Camera is already in use by another application.');
            } else {
                toast.error('Unable to access camera: ' + error.message);
            }
        }
    };

    const getDeviceInfo = async () => {
        // Try User Agent Client Hints API first (modern approach)
        if (navigator.userAgentData) {
            try {
                const hints = await navigator.userAgentData.getHighEntropyValues([
                    'model',
                    'platform',
                    'platformVersion',
                    'architecture',
                    'bitness'
                ]);
                
                // Get browser info from brands
                let browser = "Unknown";
                if (navigator.userAgentData.brands && navigator.userAgentData.brands.length > 0) {
                    // Find the main browser (not Chromium)
                    const mainBrand = navigator.userAgentData.brands.find(
                        brand => !brand.brand.includes('Chromium') && !brand.brand.includes('Not')
                    );
                    if (mainBrand) {
                        browser = mainBrand.brand;
                    } else {
                        browser = navigator.userAgentData.brands[0].brand;
                    }
                }
                
                // Build device string with model if available
                let deviceInfo = browser;
                
                if (hints.model && hints.model.trim() !== '' && hints.model !== 'Unknown') {
                    deviceInfo += ` | ${hints.model}`;
                } else if (hints.platform) {
                    deviceInfo += ` on ${hints.platform}`;
                }
                
                // Add platform version if available
                if (hints.platformVersion) {
                    deviceInfo += ` ${hints.platformVersion}`;
                }
                
                return deviceInfo;
            } catch (error) {
                console.warn('User Agent Client Hints failed, falling back to legacy detection:', error);
            }
        }
        
        // Fallback to legacy User Agent string parsing
        const ua = navigator.userAgent;
        let device = "Unknown";
        let browser = "Unknown";
        
        // Detect Browser
        if (ua.indexOf("Chrome") > -1 && ua.indexOf("Edg") === -1 && ua.indexOf("OPR") === -1) {
            browser = "Chrome";
        } else if (ua.indexOf("Firefox") > -1) {
            browser = "Firefox";
        } else if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1) {
            browser = "Safari";
        } else if (ua.indexOf("Edg") > -1) {
            browser = "Edge";
        } else if (ua.indexOf("OPR") > -1 || ua.indexOf("Opera") > -1) {
            browser = "Opera";
        }
        
        // Detect Device/OS
        if (/android/i.test(ua)) {
            device = "Android";
            // Try to extract model from UA string
            const modelMatch = ua.match(/Android[^;]*;\s*([^)]+)/);
            if (modelMatch && modelMatch[1]) {
                const model = modelMatch[1].trim();
                if (model && model !== 'Android') {
                    device = model;
                }
            }
        } else if (/iPad|iPhone|iPod/.test(ua)) {
            // Extract iPhone/iPad model
            if (/iPhone/.test(ua)) {
                device = "iPhone";
            } else if (/iPad/.test(ua)) {
                device = "iPad";
            } else {
                device = "iOS";
            }
        } else if (/Windows/.test(ua)) {
            device = "Windows";
        } else if (/Mac/.test(ua)) {
            device = "Mac";
        } else if (/Linux/.test(ua)) {
            device = "Linux";
        }
        
        // Combine browser and device
        return `${browser} on ${device}`;
    };

    const capturePhoto = async () => {
        if (!videoRef.current || !canvasRef.current) {
            toast.error('Camera not ready. Please try again.');
            return;
        }

        try {
            const video = videoRef.current;
            
            // Check if video is ready
            if (video.readyState !== video.HAVE_ENOUGH_DATA) {
                toast.error('Camera is loading. Please wait and try again.');
                return;
            }

            // Capture GPS first and get the coordinates directly
            const coords = await captureGPS();

            const canvas = canvasRef.current;
            const context = canvas.getContext('2d');

            // Set canvas to full video dimensions
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            // Draw the full photo first
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            // Get address from reverse geocoding
            let locationName = 'Location';
            let fullAddress = 'Fetching address...';
            
            if (coords) {
                try {
                    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords.latitude},${coords.longitude}&key=AIzaSyAfqU6WZUqZPqy99BkdvbvUSUR5Vcqz42k`;
                    const geocodeResponse = await fetch(geocodeUrl);
                    const geocodeData = await geocodeResponse.json();
                    
                    if (geocodeData.status === 'OK' && geocodeData.results && geocodeData.results.length > 0) {
                        const result = geocodeData.results[0];
                        fullAddress = result.formatted_address;
                        
                        // Extract city/locality for short name
                        const cityComponent = result.address_components.find(comp => 
                            comp.types.includes('locality') || comp.types.includes('administrative_area_level_2')
                        );
                        const stateComponent = result.address_components.find(comp => 
                            comp.types.includes('administrative_area_level_1')
                        );
                        const countryComponent = result.address_components.find(comp => 
                            comp.types.includes('country')
                        );
                        
                        if (cityComponent && stateComponent && countryComponent) {
                            locationName = `${cityComponent.long_name}, ${stateComponent.long_name}, ${countryComponent.long_name}`;
                        } else if (cityComponent && countryComponent) {
                            locationName = `${cityComponent.long_name}, ${countryComponent.long_name}`;
                        }
                    }
                } catch (geocodeError) {
                    console.error('Geocoding error:', geocodeError);
                    fullAddress = 'Address unavailable';
                }
            }

            // Format timestamp - exactly as shown in reference image
            const now = new Date();
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const dayName = days[now.getDay()];
            const date = now.getDate().toString().padStart(2, '0');
            const month = (now.getMonth() + 1).toString().padStart(2, '0');
            const year = now.getFullYear();
            const hours = now.getHours();
            const minutes = now.getMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const displayHours = hours % 12 || 12;
            const formattedTimestamp = `${dayName}, ${date}/${month}/${year} ${displayHours}:${minutes} ${ampm} GMT +05:30`;

            // Create GPS watermark overlay at bottom (similar to reference image)
            if (coords) {
                try {
                    // Watermark dimensions - adjust based on content (50% bigger)
                    const watermarkHeight = 300;
                    const watermarkY = canvas.height - watermarkHeight;
                    const mapSize = 270;
                    const padding = 15;
                    
                    // Draw semi-transparent dark background for watermark
                    context.fillStyle = 'rgba(0, 0, 0, 0.7)';
                    context.fillRect(0, watermarkY, canvas.width, watermarkHeight);
                    
                    // Load and draw map thumbnail on the left
                    const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=15&size=${mapSize}x${mapSize}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=AIzaSyAfqU6WZUqZPqy99BkdvbvUSUR5Vcqz42k`;
                    
                    const mapImg = new Image();
                    mapImg.crossOrigin = "anonymous";
                    
                    await new Promise((resolve) => {
                        mapImg.onload = () => {
                            context.drawImage(mapImg, padding, watermarkY + padding, mapSize, mapSize);
                            resolve();
                        };
                        mapImg.onerror = () => {
                            // Draw placeholder if map fails
                            context.fillStyle = '#2C3E50';
                            context.fillRect(padding, watermarkY + padding, mapSize, mapSize);
                            resolve();
                        };
                        setTimeout(() => resolve(), 3000);
                        mapImg.src = mapUrl;
                    });
                    
                    // Draw "GPS Map Camera" badge in top-right corner
                    const badgeText = '  GPS Map Camera';
                    context.font = 'bold 28px Arial';
                    const badgeMetrics = context.measureText(badgeText);
                    const badgeWidth = badgeMetrics.width + 60;
                    const badgeHeight = 50;
                    const badgeX = canvas.width - badgeWidth - 20;
                    const badgeY = 20;
                    
                    // Draw badge background with rounded corners effect
                    context.fillStyle = 'rgba(52, 152, 219, 0.9)';
                    context.fillRect(badgeX, badgeY, badgeWidth, badgeHeight);
                    
                    // Draw location pin icon in badge
                    context.fillStyle = '#FFF';
                    context.beginPath();
                    context.arc(badgeX + 25, badgeY + 25, 10, 0, Math.PI * 2);
                    context.fill();
                    
                    // Draw badge text
                    context.fillStyle = '#FFF';
                    context.font = 'bold 28px Arial';
                    context.textAlign = 'left';
                    context.fillText(badgeText, badgeX + 12, badgeY + 34);
                    
                    // Text area starts after map
                    const textX = padding + mapSize + 25;
                    const textMaxWidth = canvas.width - textX - padding;
                    let textY = watermarkY + 50;
                    
                    // Line 1: Location name with flag (e.g., "Jatoli, Rajasthan, India 🇮🇳")
                    context.fillStyle = '#FFFFFF';
                    context.font = 'bold 36px Arial';
                    context.textAlign = 'left';
                    context.fillText(`${locationName} 🇮🇳`, textX, textY, textMaxWidth);
                    textY += 55;
                    
                    // Line 2: Full address (e.g., "Pwvm+8ph, Jatoli, Rajasthan 328001, India")
                    context.font = '30px Arial';
                    context.fillStyle = '#E0E0E0';
                    context.fillText(fullAddress, textX, textY, textMaxWidth);
                    textY += 50;
                    
                    // Line 3: Coordinates (e.g., "Lat 26.743285° Long 77.934223°")
                    context.font = '30px Arial';
                    context.fillStyle = '#E0E0E0';
                    context.fillText(`Lat ${coords.latitude.toFixed(6)}° Long ${coords.longitude.toFixed(6)}°`, textX, textY, textMaxWidth);
                    textY += 50;
                    
                    // Line 4: Timestamp (e.g., "Tuesday, 23/12/2025 10:56 AM GMT +05:30")
                    context.font = '26px Arial';
                    context.fillStyle = '#CCCCCC';
                    context.fillText(formattedTimestamp, textX, textY, textMaxWidth);
                    textY += 45;
                    
                    // Line 5: Employee ID
                    const employeeId = localStorage.getItem("employee_id") || localStorage.getItem("in_userid") || "";
                    context.font = 'bold 28px Arial';
                    context.fillStyle = '#FFFFFF';
                    context.fillText(`Employee ID: ${employeeId}`, textX, textY, textMaxWidth);
                    textY += 45;
                    
                    // Line 6: Device Info
                    const deviceInfo = await getDeviceInfo();
                    context.font = '24px Arial';
                    context.fillStyle = '#BDC3C7';
                    context.fillText(deviceInfo, textX, textY, textMaxWidth);
                    
                } catch (overlayError) {
                    console.error('Error creating overlay:', overlayError);
                }
            }

            const photoData = canvas.toDataURL('image/jpeg', 0.9);
            setCapturedPhoto(photoData);

            closeCamera();
            toast.success('Photo captured with GPS watermark');
        } catch (error) {
            console.error('Capture error:', error);
            toast.error('Error capturing photo: ' + error.message);
        }
    };

    const closeCamera = () => {
        if (cameraStream) {
            cameraStream.getTracks().forEach(track => track.stop());
            setCameraStream(null);
        }
        setShowCamera(false);
    };

    const viewImage = (imagePath) => {
        if (!imagePath) {
            toast.error('No image available');
            return;
        }

        // Normalize the path by removing double slashes
        let normalizedPath = imagePath.replace(/\/+/g, '/');
        
        // Add navadhanftp prefix if not already present
        if (!normalizedPath.startsWith('navadhanftp/')) {
            normalizedPath = 'navadhanftp/' + normalizedPath;
        }
        
        console.log('=== View Image Debug ===');
        console.log('imagePath received:', imagePath);
        console.log('normalizedPath with prefix:', normalizedPath);

        setIsImageLoading(true);
        const generate_Id = generateId(10);
        
        // Download with the correct path including navadhanftp prefix
        const attemptDownload = (pathToTry, attemptNumber) => {
            console.log(`Attempt ${attemptNumber}: Trying path:`, pathToTry);
            
            const requestOptions = {
                method: "POST",
                headers: {
                    "api-token": api_token,
                    component_id: generate_Id1,
                    apiId: generate_Id,
                    api_group_id: "",
                    component: "PromiseToPay",
                    user_id: localStorage.getItem("in_userid"),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ "source_blob_name": pathToTry }),
            };

            customFetch(process.env.REACT_APP_FILE_DOWNLOAD + "/gcs/download", requestOptions)
                .then((res) => {
                    console.log(`Attempt ${attemptNumber} - Response Status:`, res.status);
                    
                    // Check if response is JSON (error response)
                    const contentType = res.headers.get('content-type');
                    if (contentType && contentType.includes('application/json')) {
                        return res.json().then(data => {
                            console.log(`Attempt ${attemptNumber} - JSON Error Response:`, data);
                            throw new Error(data.message || data.error || `Server error (${res.status})`);
                        });
                    }
                    if (!res.ok) {
                        console.error(`Attempt ${attemptNumber} - HTTP Error ${res.status}`);
                        throw new Error(`HTTP ${res.status}`);
                    }
                    return res.blob();
                })
                .then((blob) => {
                    const objectUrl = URL.createObjectURL(blob);
                    setPreviewImageUrl(objectUrl);
                    setShowImagePreview(true);
                    setIsImageLoading(false);
                    toast.success(`Image loaded successfully`);
                })
                .catch((error) => {
                    console.error(`Attempt ${attemptNumber} failed:`, error.message);
                    
                    // If this was attempt 1, try alternative paths
                    if (attemptNumber === 1) {
                        // Try without navadhanftp prefix in case it's already included
                        const pathWithoutPrefix = imagePath.startsWith('navadhanftp/') 
                            ? imagePath.substring(12) 
                            : imagePath;
                        console.log('Trying path without navadhanftp:', pathWithoutPrefix);
                        attemptDownload(pathWithoutPrefix, 2);
                    } else if (attemptNumber === 2) {
                        console.log('Trying original path as-is:', imagePath);
                        attemptDownload(imagePath, 3);
                    } else {
                        setIsImageLoading(false);
                        toast.error('Unable to load image: ' + error.message);
                    }
                });
        };
        
        attemptDownload(normalizedPath, 1);
    };

    const closeImagePreview = () => {
        setShowImagePreview(false);
        setPreviewImageUrl('');
    };

    const calculatePTPStatus = (ptpDate, ptpAmount, addedAt, ptpClosed) => {
        if (!ptpDate || ptpDate === 'N/A') return null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const ptp = new Date(ptpDate);
        ptp.setHours(0, 0, 0, 0);

        const marginDate = new Date(ptp);
        marginDate.setDate(marginDate.getDate() + marginPeriod);

        // This is simplified - in production, check actual payment records
        // For now, we'll determine based on date comparison
        
        if (ptpClosed) {
            return { status: 'CLOSED', label: 'Closed', color: '#1ac70a' };
        } else if (today < ptp) {
            return { status: 'PENDING', label: 'Pending', color: '#FFA500' };
        } else if (today.getTime() === ptp.getTime()) {
            return { status: 'DUE_TODAY', label: 'Due Today', color: '#FF4500' };
        } else if (today <= marginDate) {
            return { status: 'IN_MARGIN', label: 'In Margin Period', color: '#FFD700' };
        } else {
            return { status: 'PTP_NOT_HONORED', label: 'PTP Not Honored', color: '#DC3545' };
        }
    };

    const isCameraEnabled = (ptpDate) => {
        // Only show camera if there's a valid PTP date
        if (!ptpDate || ptpDate === 'N/A' || ptpDate === null) {
            // No valid PTP date, don't show camera
            return false;
        }

        try {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const ptp = new Date(ptpDate);
            if (isNaN(ptp.getTime())) return false; // Invalid date, don't show camera
            
            ptp.setHours(0, 0, 0, 0);

            const marginDate = new Date(ptp);
            marginDate.setDate(marginDate.getDate() + marginPeriod);

            // Enable camera from now until PTP date + margin period expires
            return today <= marginDate;
        } catch (error) {
            console.error('Error in isCameraEnabled:', error);
            return false; // On error, don't show camera
        }
    };

    const isUpdateButtonDisabled = () => {
        // Check if there are any active/pending PTPs in history that haven't been closed
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Block new PTP creation if there's any active PTP (not closed/expired)
        const hasActivePTP = ptpHistory.some(entry => {
            // Skip entries without valid dates
            if (!entry.rawDate || entry.rawDate === 'N/A') {
                // But if there's a recent comment-only entry (within last 24 hours), consider it active
                if (entry.comment && entry.added_at) {
                    const addedDate = new Date(entry.added_at);
                    const hoursSinceAdded = (today - addedDate) / (1000 * 60 * 60);
                    if (hoursSinceAdded < 24) return true;
                }
                return false;
            }
            
            // Check if PTP is closed (customer paid)
            if (entry.ptp_closed) {   
                return false; // Closed PTPs don't block new PTPs
            }
            
            const ptpDate = new Date(entry.rawDate);
            ptpDate.setHours(0, 0, 0, 0);
            
            // Calculate margin date (PTP date + margin period)
            const marginDate = new Date(ptpDate);
            marginDate.setDate(marginDate.getDate() + marginPeriod);
            
            // PTP is active if today is on or before the margin date
            return today <= marginDate;
        });

        return hasActivePTP;
    };

    const submitFollowUpPhoto = async (ptpRecord, index) => {
        if (!capturedPhoto || !gpsCoordinates) {
            toast.error('Photo and GPS are required');
            return;
        }

        // User must select either customer paid OR follow-up remark
        if (!customerPaid && !selectedFollowUpRemark) {
            toast.error('Please either check "Customer Paid" or select a follow-up remark');
            return;
        }

        setIsSubmitting(true);
        const uid = localStorage.getItem("in_userid");
        const employee_name = localStorage.getItem("employee_name") || localStorage.getItem("in_username") || "";
        const employee_id = localStorage.getItem("employee_id") || localStorage.getItem("in_userid") || "";

        try {
            // Create FormData with all required fields for /update/household/ptp
            const formdata = new FormData();
            
            // **CRITICAL: Get _id from the currentPtpRecord state (stored when clicking camera button)**
            if (!currentPtpRecord || !currentPtpRecord._id) {
                toast.error('Error: PTP record ID not found. Please try again.');
                setIsSubmitting(false);
                return;
            }
            
            formdata.append("_id", currentPtpRecord._id);
            formdata.append("household_number", HH_ID);
            formdata.append("employee_name", employee_name);
            formdata.append("employee_id", employee_id);
            
            // **Send visit_mode as string 'true' (backend converts to boolean)**
            formdata.append("visit_mode", "true"); // visit_made = TRUE (photo + GPS captured)
            
            // Send GPS coordinates as JSON string
            formdata.append("gps_coordinates", JSON.stringify(gpsCoordinates));
            
            // **FIX: Parse and format the date to YYYY-MM-DD**
            if (currentPtpRecord.rawDate) {
                try {
                    // Parse the date string to a Date object
                    const dateObj = new Date(currentPtpRecord.rawDate);
                    
                    // Check if date is valid
                    if (!isNaN(dateObj.getTime())) {
                        // Format as YYYY-MM-DD
                        const year = dateObj.getFullYear();
                        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                        const day = String(dateObj.getDate()).padStart(2, '0');
                        const formattedDate = `${year}-${month}-${day}`;
                        formdata.append("promise_date", formattedDate);
                    } else {
                        // If we can't parse it, send the original and hope backend can handle it
                        formdata.append("promise_date", currentPtpRecord.rawDate);
                    }
                } catch (dateError) {
                    console.error('Error formatting date:', dateError);
                    formdata.append("promise_date", currentPtpRecord.rawDate);
                }
            }
            
            if (currentPtpRecord.amount && currentPtpRecord.amount !== 'N/A') {
                formdata.append("promise_amount", currentPtpRecord.amount);
            }
            
            // Add follow-up remark and additional notes
            let remarks = currentPtpRecord.comment || '';
            if (customerPaid) {
                remarks += (remarks ? '\n' : '') + '[CUSTOMER PAID - Follow-up with photo proof]';
            } else if (selectedFollowUpRemark) {
                remarks += (remarks ? '\n' : '') + `[Follow-up: ${selectedFollowUpRemark}]`;
            }
            if (followUpRemarkText.trim()) {
                remarks += (remarks ? '\n' : '') + followUpRemarkText.trim();
            }
            formdata.append("remarks", remarks);
            
            // Convert base64 photo to blob and append as 'file' key
            const photoBlob = await fetch(capturedPhoto).then(r => r.blob());
            formdata.append("file", photoBlob, `followup_photo_${Date.now()}.jpg`);

            const generate_Id = generateId(10);
            const response = await customFetch(
                process.env.REACT_APP_URL + "/update/household/ptp",
                {
                    method: "POST",
                    body: formdata,
                    headers: {
                        "api-token": api_token,
                        component_id: generate_Id1,
                        apiId: generate_Id,
                        api_group_id: "",
                        component: "PromiseToPay",
                        user_id: uid,
                    },
                }
            );

            const data = await response.json();
            
            console.log('Photo Upload Response ');
            console.log('Response status:', response.ok);
            console.log('Response data:', data);
            console.log('Image path in response:', data.image);
            
            if (response.ok && data.status === 1) {
                toast.success('Follow-up photo submitted successfully with visit_mode flag');
                
                // Mark this PTP as closed if customer paid
                // if (customerPaid) {
                //     setClosedPTPs(prev => ({
                //         ...prev,
                //         [currentPtpRecord._id]: true
                //     }));
                // }                
                setCapturedPhoto(null);
                setGpsCoordinates(null);
                setCurrentPtpId(null);
                setCurrentPtpRecord(null);
                setSelectedFollowUpRemark('');
                setFollowUpRemarkText('');
                setCustomerPaid(false);
                fetchHouseholdData(); // Refresh the list
            } else {
                toast.error(data.message || 'Failed to submit photo');
            }
        } catch (error) {
            console.error('Error submitting photo:', error);
            toast.error('Error submitting follow-up photo: ' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleUpdate = async () => {
        const today = new Date().toISOString().split('T')[0];
        let hasError = false;

        // Check if at least one field is filled
        if (!ptpDate && !ptpAmount && !notes.trim()) {
            toast.error('Please fill at least one field.');
            hasError = true;
        }

        // If date is provided, amount is mandatory
        if (ptpDate && !ptpAmount) {
            toast.error('PTP Amount is required when PTP Date is provided.');
            hasError = true;
        }

        // If amount is provided, date is mandatory
        if (ptpAmount && !ptpDate) {
            toast.error('PTP Date is required when PTP Amount is provided.');
            hasError = true;
        }

        // Validate date only if provided
        if (ptpDate && ptpDate < today) {
            toast.error('Please select a future date.');
            hasError = true;
        }

        // Validate amount only if provided
        if (ptpAmount && parseFloat(ptpAmount) <= 0) {
            toast.error('Please enter a positive amount.');
            hasError = true;
        }

        if (!hasError) {
            setIsSubmitting(true);
            const uid = localStorage.getItem("in_userid");
            const employee_name = localStorage.getItem("employee_name") || localStorage.getItem("in_username") || "";
            const employee_id = localStorage.getItem("employee_id") || localStorage.getItem("in_userid") || "";

            const record = {
                household_number: HH_ID,
                employee_name: employee_name,
                employee_id: employee_id,
                promise_date: ptpDate || null,
                promise_amount: ptpAmount || null,
                remarks: notes.trim() || null,
                synced: false,
                timestamp: new Date().toISOString()
            };

            if (!isOnline) {
                // Save to offline DB
                try {
                    await saveToOfflineDB(record);
                    toast.success('PTP saved offline. Will sync when online.');
                    setPtpDate('');
                    setPtpAmount('');
                    setNotes('');
                } catch (error) {
                    toast.error('Error saving offline data');
                } finally {
                    setIsSubmitting(false);
                }
                return;
            }

            const formdata = new FormData();
            formdata.append("household_number", HH_ID);
            formdata.append("employee_name", employee_name);
            formdata.append("employee_id", employee_id);
            formdata.append("visit_mode", "true"); // Send visit_mode as string 'true' (backend converts to boolean)
            
            if (ptpDate) {
                formdata.append("promise_date", ptpDate);
            }
            if (ptpAmount) {
                formdata.append("promise_amount", ptpAmount);
            }
            if (notes.trim()) {
                formdata.append("remarks", notes);
            }

            try {
                const generate_Id = generateId(10);
                const response = await customFetch(
                    process.env.REACT_APP_URL + "/add/household/ptp",
                    {
                        method: "POST",
                        body: formdata,
                        headers: {
                            "api-token": api_token,
                            component_id: generate_Id1,
                            apiId: generate_Id,
                            api_group_id: "",
                            component: "PromiseToPay",
                            user_id: uid,
                        },
                    }
                );
                const data = await response.json();
                if (response.ok && data.status == 1) {
                    toast.success(data.message || "PTP details added successfully");
                    setPtpDate('');
                    setPtpAmount('');
                    setNotes('');
                    fetchHouseholdData();
                } else {
                    toast.error(data.message || "Failed to add PTP");
                }
            } catch (error) {
                toast.error("Error adding PTP");
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    const fetchHouseholdData = async () => {
        if (!api_token || !HH_ID) return;
        setIsLoading(true);
        const uid = localStorage.getItem("in_userid");
        const generate_Id = generateId(10);
        try {
            const response = await customFetch(
                process.env.REACT_APP_URL + "/fetch/household/ptp?household_no=" + HH_ID,
                {
                    method: "GET",
                    headers: {
                        "api-token": api_token,
                        component_id: generate_Id1,
                        apiId: generate_Id,
                        api_group_id: "",
                        component: "PromiseToPay",
                        user_id: uid,
                    },
                }
            );
            const data = await response.json();
            if (data.ptp_details && data.ptp_details.length > 0) {
                console.log('=== PTP Details Response ===');
                console.log('First item:', data.ptp_details[0]);
                console.log('Image field in first item:', data.ptp_details[0].image);
                
                const mappedHistory = data.ptp_details.map(item => {
                    // Handle both flat structure and nested ptp structure
                    const promiseDate = item.promise_date || null;
                    const promiseAmount = item.promise_amount || null;
                    const comment = item.comment || null;
                    const addedAt = item.added_at;
                    const agentName = item.employee_name || 'Unknown';
                    const designation = item.source || 'N/A';
                    const ptpId = item._id || null;

                    // **FIX: Store rawDate in YYYY-MM-DD format for backend compatibility**
                    let rawDate = null;
                    if (promiseDate && promiseDate !== 'None') {
                        try {
                            // Parse the date string to a Date object
                            const dateObj = new Date(promiseDate);
                            
                            // Check if date is valid
                            if (!isNaN(dateObj.getTime())) {
                                // Format as YYYY-MM-DD
                                const year = dateObj.getFullYear();
                                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                                const day = String(dateObj.getDate()).padStart(2, '0');
                                rawDate = `${year}-${month}-${day}`;
                            } else {
                                // If we can't parse it, keep original
                                rawDate = promiseDate;
                            }
                        } catch (dateError) {
                            console.error('Error parsing date:', dateError);
                            rawDate = promiseDate;
                        }
                    }

                    // **FIX: Auto-detect closed PTPs based on image and comment**
                    const hasFollowUpImage = item.image && item.image.trim() !== '';
                    const hasCustomerPaidComment = comment && (comment.includes('[CUSTOMER PAID]') || comment.includes('CUSTOMER PAID - Follow-up'));
                    const isAutoDetectedClosed = hasFollowUpImage && hasCustomerPaidComment;
                    
                    return {
                        _id: ptpId,  // **CRITICAL: Include _id in the mapped object**
                        date: promiseDate && promiseDate !== 'None' ? new Date(promiseDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                        }) : 'N/A',
                        rawDate: rawDate, // **Store in YYYY-MM-DD format**
                        amount: promiseAmount && promiseAmount !== 'None' && !isNaN(parseFloat(promiseAmount))
                            ? parseFloat(promiseAmount)
                            : 'N/A',
                        comment: comment,
                        source: item.source || 'N/A',
                        added_at: addedAt,
                        created_by: agentName,
                        designation: designation,
                        image: item.image || null, // **Store image URL if available**
                        isClosed: comment && (comment.includes('[CUSTOMER PAID]') || comment.includes('CUSTOMER PAID - Follow-up')), // **Check if PTP is closed**
                        ptp_closed: item.ptp_closed || isAutoDetectedClosed // **Backend flag or auto-detected based on image + comment**
                    };
                });
                
                // Sort in descending order by added_at (newest first)
                mappedHistory.sort((a, b) => {
                    const dateA = new Date(a.added_at);
                    const dateB = new Date(b.added_at);
                    
                    // Handle invalid dates
                    if (isNaN(dateA.getTime())) return 1;
                    if (isNaN(dateB.getTime())) return -1;
                    
                    return dateB.getTime() - dateA.getTime();
                });
                
                console.log('Sorted PTP History:', mappedHistory.map(h => ({ added_at: h.added_at, date: h.date })));
                setPtpHistory(mappedHistory);
            }
        } catch (error) {
            toast.error("Error fetching household data");
        } finally {
            setIsLoading(false);
        }
    };

    const fetchConfiguration = async () => {
        const uid = localStorage.getItem("in_userid");
        const generate_Id = generateId(10);
        try {
            // Fetch margin_period
            const marginResponse = await customFetch(
                process.env.REACT_APP_URL + "/get/configuration/parameter/master?parameter_name=margin_period",
                {
                    method: "GET",
                    headers: {
                        "api-token": api_token,
                        component_id: generate_Id1,
                        apiId: generate_Id,
                        api_group_id: "",
                        component: "PromiseToPay",
                        user_id: uid,
                    },
                }
            );
            const marginData = await marginResponse.json();
            if (marginResponse.ok && marginData && marginData.parameter_value !== undefined) {
                setMarginPeriod(parseInt(marginData.parameter_value) || 3);
            }

            // Fetch ptp_follow_up_remarks
            const remarksResponse = await customFetch(
                process.env.REACT_APP_URL + "/get/configuration/parameter/master?parameter_name=ptp_follow_up_remarks",
                {
                    method: "GET",
                    headers: {
                        "api-token": api_token,
                        component_id: generate_Id1,
                        apiId: generateId(10),
                        api_group_id: "",
                        component: "PromiseToPay",
                        user_id: uid,
                    },
                }
            );
            const remarksData = await remarksResponse.json();
            console.log('Follow-up remarks API response:', remarksData);
            
            if (remarksResponse.ok && remarksData && remarksData.parameter_value !== undefined) {
                try {
                    console.log('Raw parameter_value:', remarksData.parameter_value);
                    console.log('Type of parameter_value:', typeof remarksData.parameter_value);
                    
                    // Clean up parameter_value: replace curly quotes with straight quotes
                    let cleanedValue = remarksData.parameter_value;
                    // Replace Unicode curly quotes with straight quotes
                    cleanedValue = cleanedValue.replace(/[\u201C\u201D\u201c\u201d]/g, '"');
                    // Replace Unicode single quotes if any
                    cleanedValue = cleanedValue.replace(/[\u2018\u2019]/g, "'");
                    
                    console.log('Cleaned parameter_value:', cleanedValue);
                    
                    const remarksArray = JSON.parse(cleanedValue);
                    console.log('Parsed remarks array:', remarksArray);
                    console.log('Is array:', Array.isArray(remarksArray));
                    console.log('Array length:', remarksArray && remarksArray.length);
                    
                    if (Array.isArray(remarksArray) && remarksArray.length > 0) {
                        setFollowUpRemarksOptions(remarksArray);
                        setFollowUpRemarksEnabled(true);
                        console.log('✅ Follow-up remarks loaded successfully:', remarksArray);
                        } else {
                        console.warn('Follow-up remarks array is empty or not an array');
                        setFollowUpRemarksOptions([]);
                        setFollowUpRemarksEnabled(false);
                    }
                } catch (e) {
                    console.error('❌ Error parsing follow-up remarks:', e);
                    console.error('Failed parameter_value:', remarksData.parameter_value);
                    setFollowUpRemarksOptions([]);
                    setFollowUpRemarksEnabled(false);
                }
            } else {
                console.warn('Follow-up remarks not configured (parameter_value undefined)');
                setFollowUpRemarksOptions([]);
                setFollowUpRemarksEnabled(false);
            }

            console.log('Configuration loaded - Margin Period:', marginPeriod, 'Follow-up Remarks Enabled:', followUpRemarksEnabled);
            } catch (error) {
                console.error("Error fetching configuration:", error);
                // Disable follow-up remarks if we can't load configuration
                setFollowUpRemarksOptions([]);
                setFollowUpRemarksEnabled(false);
            }
    };

    useEffect(() => {
        fetchConfiguration();
        fetchHouseholdData();

        // Initialize speech recognition
        if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            const recognitionInstance = new SpeechRecognition();
            recognitionInstance.continuous = false;
            recognitionInstance.interimResults = false;

            // Support for Indian languages - will auto-detect or can be set to specific language
            recognitionInstance.lang = 'en-IN'; // English (India) - also understands Hinglish
            // Other options: 'hi-IN' (Hindi), 'mr-IN' (Marathi), 'ta-IN' (Tamil), 'te-IN' (Telugu), etc.

            recognitionInstance.onresult = (event) => {
                const transcript = event.results[0][0].transcript;
                setNotes(prevNotes => prevNotes + (prevNotes ? ' ' : '') + transcript);
                setIsListening(false);
            };

            recognitionInstance.onerror = (event) => {
                toast.error('Speech recognition error: ' + event.error);
                setIsListening(false);
            };

            recognitionInstance.onend = () => {
                setIsListening(false);
            };

            setRecognition(recognitionInstance);
        }

        return () => {
            if (cameraStream) {
                cameraStream.getTracks().forEach(track => track.stop());
            }
        };
    }, []);

    const startListening = () => {
        if (recognition) {
            setIsListening(true);
            recognition.start();
        } else {
            toast.error('Speech recognition not supported in this browser');
        }
    };

    const stopListening = () => {
        if (recognition) {
            recognition.stop();
            setIsListening(false);
        }
    };

    return (
        <>
            <div className="container">
                <div className="top_nav">
                    <a>
                        <div className="icon_bg" onClick={() => history.goBack()}>
                            <img
                                src={require("../assets/images/back.png")}
                                className="icon_img"
                            />
                        </div>
                    </a>
                    <span className="head-title" style={{ display: 'flex', alignItems: 'center' }}>
                        Visit Notes
                        {!isOnline && <span className="badge badge-warning ml-2" style={{ fontSize: '0.7rem' }}>Offline</span>}
                    </span>
                    <a>
                        {flag === 0 && (
                            <div className="log-out-deposit">
                                <img
                                    src={require("../assets/images/power-off.png")}
                                    onClick={() => logout(null, null, true)}
                                    alt=""
                                />
                            </div>
                        )}
                    </a>
                </div>

                <div className="mt-4">
                    {/* Customer Information */}
                    <div className="card mb-4" >
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <strong>Household Number:</strong> {HH_ID}
                                </div>
                                <div className="col-md-4">
                                    <strong>Phone:</strong> {smsmobile}
                                </div>
                                <div className="col-md-4">
                                    <strong>Name:</strong> {Lead_Name}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Active PTP Warning Message */}
                    {isUpdateButtonDisabled() && (
                        <div className="alert alert-warning mb-4" role="alert">
                            <strong>Active PTP Exists:</strong> You cannot create a new PTP as there is already an active PTP within the margin period. Please wait until the current PTP is closed or the margin period expires.
                        </div>
                    )}

                    {/* PTP Entry Form */}
                    <div className="card mb-4" >
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-5">
                                    <label htmlFor="ptpDate">PTP Date</label>
                                    <div className="input-group">
                                        <input
                                            type="date"
                                            className="form-control"
                                            min={new Date().toISOString().split('T')[0]}
                                            max="9999-12-31"
                                            id="ptpDate"
                                            value={ptpDate}
                                            onChange={(e) => setPtpDate(e.target.value)}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text"><i className="fas fa-calendar"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5" style={{ marginTop: window.innerWidth <= 768 ? '1rem' : '0', marginBottom: window.innerWidth <= 768 ? '1rem' : '0' }}>
                                    <label htmlFor="ptpAmount">PTP Amount</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">₹</span>
                                        </div>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="ptpAmount"
                                            value={ptpAmount}
                                            onChange={handle_amount_update}
                                            onKeyDown={(e) => {
                                                // Prevent 'e', 'E', '-', '+' keys
                                                if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                                                    e.preventDefault();
                                                }
                                            }}
                                            placeholder="Enter amount"
                                            step="0.01"
                                            min="0"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-end mb-1">
                                    <button
                                        className="btn btn-primary w-100 "
                                        onClick={handleUpdate}
                                        disabled={isSubmitting || isUpdateButtonDisabled()}
                                        title={isUpdateButtonDisabled() ? 'Update button will be enabled after PTP date + margin period expires' : ''}
                                    >
                                        {(isSubmitting) ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                Submitting...
                                            </>
                                        ) : (
                                            'Update'
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Comments Section with Speech-to-Text */}
                            <div className="row mt-4">
                                <div className="col-12">
                                    <label htmlFor="notes">
                                        <i className="bi bi-chat-left-text" style={{ marginRight: '8px', color: '#60A5FA' }}></i>
                                        Comments
                                    </label>
                                    <textarea
                                        className="form-control mb-2"
                                        id="notes"
                                        rows="3"
                                        placeholder="Enter visit comments or use voice input"
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}
                                        style={{ resize: 'vertical' }}
                                    ></textarea>
                                    <div className="d-flex gap-2 flex-wrap align-items-center">
                                        <button
                                            className={`btn btn-sm ${isListening ? 'btn-danger' : 'btn-outline-primary'}`}
                                            onClick={isListening ? stopListening : startListening}
                                            type="button"
                                        >
                                            <i className={`bi ${isListening ? 'bi-mic-fill' : 'bi-mic'}`} style={{ marginRight: '5px' }}></i>
                                            {isListening ? 'Stop Recording' : 'Voice Input'}
                                        </button>
                                        {notes && (
                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => setNotes('')}
                                                type="button"
                                            >
                                                Clear Comments
                                            </button>
                                        )}
                                        {isListening && (
                                            <small className="text-muted">
                                                <i className="bi bi-soundwave" style={{ marginRight: '5px' }}></i>
                                                Listening...
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Historical PTP Records */}
                    <div className="" >
                        <div className="">
                            {isLoading ? (
                                <div className="ptp-list">
                                    {[1, 2, 3].map((skeleton) => (
                                        <div
                                            key={skeleton}
                                            className="ptp-item position-relative"
                                            style={{
                                                border: '1px solid #f0f0f0',
                                                borderRadius: '10px',
                                                padding: '16px',
                                                marginBottom: '10px',
                                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                                backgroundColor: '#fff',
                                            }}
                                        >
                                            {/* Skeleton animation */}
                                            <style>{`
                                                @keyframes shimmer {
                                                    0% { background-position: -468px 0; }
                                                    100% { background-position: 468px 0; }
                                                }
                                                .skeleton {
                                                    animation: shimmer 1.5s infinite linear;
                                                    background: linear-gradient(to right, #f0f0f0 8%, #e0e0e0 18%, #f0f0f0 33%);
                                                    background-size: 800px 104px;
                                                    border-radius: 4px;
                                                }
                                            `}</style>
                                            
                                            {/* Top row skeleton */}
                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <div className="skeleton" style={{ width: '40%', height: '16px' }}></div>
                                                <div className="d-flex" style={{ gap: '8px' }}>
                                                    <div className="skeleton" style={{ width: '80px', height: '24px', borderRadius: '12px' }}></div>
                                                    <div className="skeleton" style={{ width: '120px', height: '24px', borderRadius: '12px' }}></div>
                                                </div>
                                            </div>

                                            {/* Date and Amount skeleton */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div>
                                                    <div className="skeleton" style={{ width: '60px', height: '12px', marginBottom: '8px' }}></div>
                                                    <div className="skeleton" style={{ width: '100px', height: '18px' }}></div>
                                                </div>
                                                <div className="text-end">
                                                    <div className="skeleton" style={{ width: '80px', height: '12px', marginBottom: '8px', marginLeft: 'auto' }}></div>
                                                    <div className="skeleton" style={{ width: '90px', height: '18px', marginLeft: 'auto' }}></div>
                                                </div>
                                            </div>

                                            {/* Comment skeleton */}
                                            {skeleton <= 2 && (
                                                <div style={{
                                                    backgroundColor: '#f8f9fa',
                                                    padding: '12px',
                                                    borderRadius: '6px',
                                                    borderLeft: '3px solid #e0e0e0',
                                                }}>
                                                    <div className="skeleton" style={{ width: '80px', height: '14px', marginBottom: '8px' }}></div>
                                                    <div className="skeleton" style={{ width: '100%', height: '14px', marginBottom: '6px' }}></div>
                                                    <div className="skeleton" style={{ width: '70%', height: '14px' }}></div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : ptpHistory.length === 0 ? (
                                <p>No PTP records found.</p>
                            ) : (
                                <div className="ptp-list">
                                    {ptpHistory.map((entry, index) => {
                                        const statusInfo = calculatePTPStatus(entry.rawDate, entry.amount, entry.added_at, entry.ptp_closed);
                                        const cameraEnabled = isCameraEnabled(entry.rawDate);
                                        const isClosed = entry.ptp_closed;  // Removed manual closedPTPs state
                                        
                                        return (
                                        <div
                                            key={index}
                                            className="ptp-item position-relative"
                                            style={{
                                                border: '1px solid #f0f0f0',
                                                borderRadius: '10px',
                                                padding: '16px',
                                                marginBottom: '10px',
                                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                                backgroundColor: isClosed ? '#f5f5f5' : '#fff',
                                                opacity: isClosed ? 0.7 : 1,
                                                pointerEvents: 'none'
                                            }}
                                        >
                                            {/* Overlay div to allow View Photo button to be clickable */}
                                            <div style={{ pointerEvents: 'auto' }}>
                                            {/* Top row: Created datetime and User info with Status Badge */}
                                            <div className="d-flex justify-content-between align-items-start flex-wrap mb-3" style={{ gap: '8px' }}>
                                                <div style={{ fontSize: '0.85rem', color: '#666', pointerEvents: 'none' }}>
                                                    <i className="bi bi-clock" style={{ marginRight: '4px', color: '#60A5FA' }}></i> Created At&nbsp;
                                                    {entry.added_at ? new Date(entry.added_at).toLocaleString('en-US', {
                                                        year: 'numeric',
                                                        month: 'short',
                                                        day: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    }) : 'N/A'}
                                                </div>
                                                <div className="d-flex align-items-center" style={{ gap: '8px', flexWrap: 'wrap' }}>
                                                    {/* Status Badge */}
                                                    {isClosed ? (
                                                        <span
                                                            className="badge"
                                                            style={{ 
                                                                backgroundColor: '#28a745',
                                                                color: 'white',
                                                                fontSize: '0.7rem',
                                                                padding: '4px 8px'
                                                            }}
                                                        >
                                                            <i className="bi bi-check-circle" style={{ marginRight: '4px' }}></i> Closed
                                                        </span>
                                                    ) : statusInfo && (
                                                        <span
                                                            className="badge"
                                                            style={{ 
                                                                backgroundColor: statusInfo.color,
                                                                color: 'white',
                                                                fontSize: '0.7rem',
                                                                padding: '4px 8px'
                                                            }}
                                                        >
                                                            {statusInfo.label}
                                                        </span>
                                                    )}
                                                    {/* User Badge */}
                                                    <span
                                                        className="badge"
                                                        style={{ border: "1px solid #60A5FA", fontSize: '0.75rem' }}
                                                    >
                                                        {(!entry.created_by || entry.created_by === 'Unknown' || entry.created_by === '')
                                                            ? entry.designation
                                                            : `${entry.created_by} as ${entry.designation}`}
                                                    </span>

                                                    {/* View Image Button - Show if PTP is closed and image exists */}
                                                    {isClosed && entry.image && (
                                                        <button
                                                            className="btn btn-sm btn-outline-info"
                                                            onClick={() => viewImage(entry.image)}
                                                            disabled={isImageLoading}
                                                            style={{ 
                                                                padding: '2px 8px',
                                                                fontSize: '0.7rem',
                                                                marginLeft: '4px'
                                                            }}
                                                            title="View Uploaded Photo"
                                                        >
                                                            {isImageLoading ? (
                                                                <>
                                                                    <i className="bi bi-hourglass-split" style={{ marginRight: '4px' }}></i>
                                                                    Loading...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="bi bi-image"></i> View Photo
                                                                </>
                                                            )}
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Bottom row: PTP Date and Amount */}
                                            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <i className="bi bi-calendar" style={{ color: '#60A5FA', fontSize: '1.2rem' }}></i>
                                                    <div>
                                                        <small style={{ color: '#888' }}>PTP Date</small>
                                                        <div style={{ fontWeight: '500' }}>{entry.date}</div>
                                                    </div>
                                                </div>

                                                {/* Right aligned amount */}
                                                <div className="text-end mt-2 mt-sm-0" style={{ minWidth: '100px' }}>
                                                    <small style={{ color: '#888' }}>PTP Amount</small>
                                                    <div style={{ fontWeight: '600' }}>
                                                        {typeof entry.amount === 'number' ? `₹${entry.amount.toLocaleString()}` : entry.amount}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Comment Section */}
                                            {entry.comment && (
                                                <div style={{
                                                    backgroundColor: '#f8f9fa',
                                                    padding: '12px',
                                                    borderRadius: '6px',
                                                    borderLeft: '3px solid #60A5FA',
                                                    marginBottom: '12px'
                                                }}>
                                                    <small style={{ color: '#888', fontWeight: '500' }}>
                                                        <i className="bi bi-chat-left-text" style={{ marginRight: '6px' }}></i>
                                                        Comment:
                                                    </small>
                                                    <div style={{
                                                        marginTop: '6px',
                                                        color: '#333',
                                                        fontSize: '0.9rem',
                                                        whiteSpace: 'pre-wrap',
                                                        wordBreak: 'break-word'
                                                    }}>
                                                        {entry.comment.replace(/_x000D_\r\n/g, '\n').replace(/_x000D_/g, '\n')}
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {/* Camera Button - Only show if within PTP date + margin period AND not closed */}
                                            {cameraEnabled && !isClosed && (
                                                <div className="mt-3">
                                                    {!showCamera || currentPtpId !== index ? (
                                                        <button
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={() => {
                                                                setCurrentPtpId(index);
                                                                setCurrentPtpRecord(entry); //Store the complete PTP record with _id
                                                                openCamera();
                                                            }}
                                                        >
                                                            <i className="bi bi-camera" style={{ marginRight: '5px' }}></i>
                                                            Capture Follow-up Photo
                                                        </button>
                                                    ) : (
                                                        <div className="mt-2">
                                                            <div style={{ 
                                                                position: 'relative',
                                                                width: '100%',
                                                                backgroundColor: '#000',
                                                                borderRadius: '8px',
                                                                overflow: 'hidden'
                                                            }}>
                                                                <video
                                                                    ref={videoRef}
                                                                    autoPlay
                                                                    playsInline
                                                                    muted
                                                                    style={{ 
                                                                        width: '100%', 
                                                                        height: 'auto',
                                                                        display: 'block'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="mt-2">
                                                                <button
                                                                    className="btn btn-success btn-sm mr-2"
                                                                    onClick={capturePhoto}
                                                                >
                                                                    <i className="bi bi-camera-fill"></i> Capture
                                                                </button>
                                                                <button
                                                                    className="btn btn-secondary btn-sm"
                                                                    onClick={() => {
                                                                        closeCamera();
                                                                        setCurrentPtpId(null);
                                                                        setCurrentPtpRecord(null); // Clear the stored record
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {capturedPhoto && currentPtpId === index && (
                                                        <div className="mt-2">
                                                            <img
                                                                src={capturedPhoto}
                                                                alt="Follow-up"
                                                                style={{ width: '100%', borderRadius: '8px', marginBottom: '12px' }}
                                                            />
                                                            
                                                            {/* Customer Paid Checkbox and Follow-up Remarks Section - Side by Side */}
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', flexWrap: 'wrap', marginBottom: '16px' }}>
                                                                {/* Customer Paid Checkbox - Commented out as per request */}
                                                                {/*
                                                                <div style={{ flex: '1', minWidth: '250px' }}>
                                                                    <div className="form-check" style={{ 
                                                                        padding: '12px', 
                                                                        backgroundColor: '#f8f9fa', 
                                                                        borderRadius: '6px',
                                                                        border: customerPaid ? '2px solid #28a745' : '1px solid #dee2e6',
                                                                        height: '100%'
                                                                    }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input ml-0"
                                                                            id={`customerPaid-${index}`}
                                                                            name={`customerPaid-${index}`}
                                                                            checked={customerPaid}
                                                                            onChange={(e) => {
                                                                                setCustomerPaid(e.target.checked);
                                                                                // Optionally clear follow-up remark when checking this
                                                                                if (e.target.checked) {
                                                                                    setSelectedFollowUpRemark('');
                                                                                    setFollowUpRemarkText('');
                                                                                }
                                                                            }}
                                                                            style={{ cursor: 'pointer' }}
                                                                        />&nbsp;
                                                                        <label 
                                                                            className="form-check-label" 
                                                                            htmlFor={`customerPaid-${index}`}
                                                                            style={{ 
                                                                                fontWeight: '500', 
                                                                                fontSize: '0.95rem',
                                                                                cursor: 'pointer',
                                                                                marginLeft: '5px'
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-cash-coin" style={{ marginRight: '8px', color: '#28a745' }}></i>
                                                                            Customer Paid
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                */}

                                                                {/* OR Divider - Commented out along with checkbox */}
                                                                {/*
                                                                <div style={{ 
                                                                    display: 'flex', 
                                                                    alignItems: 'center', 
                                                                    justifyContent: 'center',
                                                                    color: '#6c757d',
                                                                    fontWeight: '500',
                                                                    fontSize: '0.85rem',
                                                                    padding: '0 10px'
                                                                }}>
                                                                    OR
                                                                </div>
                                                                */}
                                                                
                                                                {/* Follow-up Remarks Section */}
                                                                {followUpRemarksEnabled && followUpRemarksOptions.length > 0 && (
                                                                    <div style={{ flex: '1', minWidth: '250px' }}>
                                                                        <label htmlFor={`followUpRemark-${index}`} style={{ fontWeight: '500', fontSize: '0.9rem', marginBottom: '6px', display: 'block' }}>
                                                                            <i className="bi bi-chat-dots" style={{ marginRight: '6px' }}></i>
                                                                            Follow-up Remark
                                                                        </label>
                                                                        <select
                                                                            id={`followUpRemark-${index}`}
                                                                            name={`followUpRemark-${index}`}
                                                                            className="form-control form-control-sm mb-2"
                                                                            value={selectedFollowUpRemark}
                                                                            onChange={(e) => {
                                                                                setSelectedFollowUpRemark(e.target.value);
                                                                                // Optionally uncheck customer paid when selecting a remark
                                                                                if (e.target.value) {
                                                                                    setCustomerPaid(false);
                                                                                }
                                                                            }}
                                                                            style={{ fontSize: '0.85rem' }}
                                                                            disabled={customerPaid}
                                                                        >
                                                                            <option value="">-- Select Reason --</option>
                                                                            {followUpRemarksOptions.map((remark, idx) => (
                                                                                <option key={idx} value={remark}>{remark}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="mt-2">
                                                                {/* Optional free-text remarks */}
                                                                <textarea
                                                                    id={`followUpRemarkText-${index}`}
                                                                    name={`followUpRemarkText-${index}`}
                                                                    className="form-control form-control-sm"
                                                                    rows="2"
                                                                    placeholder="Additional notes (optional)"
                                                                    value={followUpRemarkText}
                                                                    onChange={(e) => setFollowUpRemarkText(e.target.value)}
                                                                    style={{ fontSize: '0.85rem', resize: 'vertical' }}
                                                                    disabled={customerPaid}
                                                                ></textarea>
                                                            </div>

                                                            <div className="mt-2">
                                                                <button
                                                                    className="btn btn-success btn-sm mr-2"
                                                                    onClick={() => submitFollowUpPhoto(entry, index)}
                                                                    disabled={isSubmitting}
                                                                >
                                                                    {isSubmitting ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                                                            Submitting...
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <i className="bi bi-check-circle"></i> Submit Photo
                                                                        </>
                                                                    )}
                                                                </button>
                                                                <button
                                                                    className="btn btn-outline-danger btn-sm"
                                                                    onClick={() => {
                                                                        setCapturedPhoto(null);
                                                                        setGpsCoordinates(null);
                                                                        setCurrentPtpId(null);
                                                                        setCurrentPtpRecord(null); // Clear the stored record
                                                                        setSelectedFollowUpRemark('');
                                                                        setFollowUpRemarkText('');
                                                                        setCustomerPaid(false);
                                                                    }}
                                                                    disabled={isSubmitting}
                                                                >
                                                                    <i className="bi bi-trash"></i> Retake
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <canvas ref={canvasRef} style={{ display: 'none' }} />
                                                </div>
                                            )}

                                            {/* Show closed message if PTP is closed */}
                                            {isClosed && cameraEnabled && (
                                                <div className="mt-3">
                                                    <span className="badge badge-success" style={{ padding: '8px 12px', fontSize: '0.9rem' }}>
                                                        <i className="bi bi-check-circle-fill" style={{ marginRight: '6px' }}></i>
                                                        PTP Closed - Customer Paid
                                                    </span>
                                                </div>
                                            )}
                                            </div>
                                            {/* Close overlay div */}
                                        </div>
                                    )})}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Image Preview Modal */}
            {showImagePreview && (
                <div 
                    className="modal-backdrop" 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        zIndex: 1050,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    onClick={closeImagePreview}
                >
                    <div 
                        style={{
                            maxWidth: '95%',
                            maxHeight: '95%',
                            position: 'relative'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={closeImagePreview}
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '0',
                                zIndex: 1060
                            }}
                        >
                            <i className="bi bi-x-lg"></i> Close
                        </button>
                        <img
                            src={previewImageUrl}
                            alt="PTP Photo"
                            onError={(e) => {
                                console.error('Image failed to load:', previewImageUrl);
                                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23f0f0f0" width="400" height="300"/%3E%3Ctext x="50%25" y="50%25" font-family="Arial" font-size="16" fill="%23999" text-anchor="middle" dy=".3em"%3EImage Failed to Load%3C/text%3E%3C/svg%3E';
                            }}
                            onLoad={() => console.log('Image loaded successfully')}
                            style={{
                                width: '100%',
                                height: 'auto',
                                borderRadius: '8px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
                            }}
                        />
                    </div>
                </div>
            )}

            <Toaster />
        </>
    );
}

export default PromiseToPay;